<template lang="pug">
    .product-display--wrapper
      .product-display
        .container
          .product-display__images
            swiper(ref="mySwiper" class="swiper" :options="swiperOptions")
              swiper-slide.product-display__slide(v-for="(item, index) in imagesList", :key="item.id")
                img(:src="item.src", :image-id="item.id")
              div(class="swiper-button-prev" slot="button-prev")
              div(class="swiper-button-next" slot="button-next")
          .product-display__content
            .product-display__heading
              h1(v-html="title")  
              .product-display__options(v-if="product")
                product-form(
                  :product="product"
                  :variants="variants"
                  :bundle="bundle"
                )     
            .product-display__description
              p(v-if="description" v-html="description") 
            .product-display__moreDetails(v-if="moreDetails.length > 0")
              .product-display__moreDetails__body
                span(@click="openDetails" :class="{ 'close': openMoreDetails }") More Details
                div.details(:class="{ 'open': openMoreDetails }")
                  div(v-for="(item, index) in moreDetails", :key="item.id")
                    h2 {{ item.title }}
                    div(v-html="item.description") 
</template>

<script>
  import { mapState } from 'vuex'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'; 
  import ProductForm from '../product/ProductForm.vue'
  import SubmitButton from '../buttons/SubmitButton.vue'

  export default {
    name: 'ProductDisplay',
    data: {
      testval: 2
    },
    components: {
      swiper,
      swiperSlide,
      ProductForm,
      SubmitButton
    },
    props: {
      title: String,
      handle: String,
      featuredImage: { 
        type: Array
      },
      description: String, 
      variants: { 
        type: Array
      },
      moreDetails: { 
        type: Array
      },
      productBundle: {
        type: Array
      },
      productType: String
    },
    data () {
      return {        
        openMoreDetails: false,
        swiperOptions: {
          slidesPerView: 1,
          spaceBetween: 10, 
          loop: false,
          autoHeight: true,
          nextButton: '.swiper-button-next',
          prevButton: '.swiper-button-prev'
        }
      }
    },
    computed: {
      ...mapState({
        products: state => state.products.all,
      }),
      product () {
        return this.products.find(product => product.handle === this.handle)
      },
      bundle() {
        return this.productBundle;
      },
      imagesList(){
          return this.featuredImage;
      }


    },
    methods: {
      openDetails() {
        this.openMoreDetails = !this.openMoreDetails;        
      }
    },
    mounted(){
      // delete this part. 
    },
    created() {
      this.$store.dispatch('products/getProductInfo', [{ handle: this.handle }]);  
    }

  }
</script>


<style lang="scss" scoped>
  .product-display {   
    
    &__moreDetails {   
      span { 
        margin-bottom: 10px;
        display: flex;
        cursor: pointer; 
        width: 100%;

        &:after {          
          content: '+';
          position: relative; 
          color: #fff;
          padding-left: 5px;
        }

        &.close {
          &:after {
            content: '-';
          }
        }
      }

      &__body { 

        .details {
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.25s ease-in-out;
          margin-top: 34px;

          &.open {
            max-height: 1000px;
          }
        }
      }

    }

    &__description {
      margin-bottom: 30px;
      p {
        font-family: 'basiersquare';
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.57;
        letter-spacing: normal;
        text-align: left;
        color: #fff;
        margin-bottom:15px;
      }
    }

    &__description p{
      margin-bottom:15px;
    }

    .swiper-button-prev, .swiper-button-next { 
      width: 42px;
      height: 42px;
      background-color: rgba(73, 73, 73 , 0.5);
      border-radius: 100%;

      &:after {
        color: #ffffff;
        font-size: 15px;
        font-weight: bold; 
      }
    }

    img {
      width: 100%;
    }

    &__content {
      padding-left: 20%; 
      
      @media screen and (max-width: 767px) { 
        padding-left: 0; 
      }
    }

    &--wrapper {
      padding: 80px 60px;     
      
      @media screen and (max-width: 767px) { 
        padding: 24px 20px 56px; 
      }
    }

    &__images {
      width: 100%;
      overflow: hidden;
    }

    .container {
      display: grid;
      grid-template-columns: 1fr 1fr;
      padding:0;
      @media screen and (max-width: 767px) { 
        grid-template-columns: 1fr; 
        padding: 0;
      }
    }
  }

</style>

